import { render, staticRenderFns } from "./mediaHome.vue?vue&type=template&id=d12d48a4&"
import script from "./mediaHome.vue?vue&type=script&lang=js&"
export * from "./mediaHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports